module.exports = __webpack_public_path__ + "img/kpi.8dc07652.svg";